import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './assets/css/reset.css';
import './assets/css/style.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)


import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

//引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import VueLazyload from 'vue-lazyload'
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
    key: '1cc04d4a4a033440de549454232eaa1d',
    plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
    v: '1.4.4',
    uiVersion: '1.0'
})


Vue.config.productionTip = false
import global_ from './components/common'
//设置超时时间
axios.defaults.timeout = 5000
    //设置api地址
    //全局定义axios
    // axios.defaults.baseURL = 'http://shkjgw.shkjem.com/api/'
// axios.defaults.baseURL = 'http://s3wu2v.natappfree.cc/'
axios.defaults.baseURL = global_.httpUrl;
    // axios.defaults.baseURL = 'http://192.168.11.189:6690/'
Vue.prototype.$http = axios
Vue.prototype.$axios = axios
    // 图片服务器地址
    // Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'
// Vue.prototype.imgserver = 'http://192.168.11.189:6690/'
Vue.prototype.imgserver = global_.httpUrl
    // axios.defaults.baseURL = 'http://192.168.11.189:6690/'
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')



// require('./assets/css/style.css')